function NormalCell({ dataItem, field, hidden }) {
    return (
        <td>
            <span className={hidden && "text-muted"}>
                {dataItem[field]}
            </span>
        </td>
    )
}

export default NormalCell;